// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-input[data-v-6f35b202] .v-label{margin-bottom:0!important}", "",{"version":3,"sources":["webpack://./bgo/bgo-components/resources/js/components/BInput.vue"],"names":[],"mappings":"AAEI,mCACI,yBADR","sourcesContent":["\n.v-input::v-deep {\n    .v-label {\n        margin-bottom: 0 !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
